import spinner from 'assets/spinner.svg'
import yellowSpinner from 'assets/spinner-yellow.svg'
const Spinner = ({
    yellow = false,
    className = '',
}: {
    yellow?: boolean
    className?: string
}) => {
    return (
        <img
            className={`animate-spin ${className}`}
            src={yellow ? yellowSpinner : spinner}
            alt="loading"
        />
    )
}

export default Spinner
